<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="text-center">
                        <h3 class="mb-5">Edit registered account details?</h3>
                        <p>Please get in touch with one of the team for more information.</p>
                        <ul class="list-group list-group-flush mx-auto">
                            <li class="list-group-item border-0">
                                <a class="text-tertiary heading-large font-weight-normal" :href="`tel:${OLF_PHONE_NUMBER}`">
                                    <i class="fas fa-phone mr-2 text-primary" />{{ OLF_PHONE_NUMBER }}
                                </a>
                            </li>
                            <li class="list-group-item border-0">
                                <a class="text-tertiary heading-large font-weight-normal" :href="`mailto:info@onlinefuels.com`">
                                    <i class="fas fa-envelope mr-2 text-primary" />{{ OLF_EMAIL }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="modal-footer d-flex justify-content-center">
                    <button class="btn btn-tertiary"  @click="closeThisModal()">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import breakpoint from '@/mixins/index';

export default {
    mixins: [breakpoint],
    data(){
        return {
            OLF_PHONE_NUMBER: "+44 (0) 20 3675 5000",
            OLF_EMAIL: "info@onlinefuels.com"
        }
    },
    methods: {
        closeThisModal: function(){
            $(this.$el).modal('hide');
            this.$emit("closeModal");
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/_modals.scss";
</style>